import React from "react";
import {
    RenderDateTime,
    RenderMoneda,
    RenderNumero
} from "Utils/renderField/renderTableField";
import { formatFraction, formatDifference } from "utility/variables";

var HistorialPDF = function(props) {
    var data = props.data || [];
    var conf_tipo_negocio = props.conf_tipo_negocio;
    var hideCabecera = props.hideCabecera;
    var totalDiferencia = props.totalDiferencia || 0;
    var totalPrecio = props.totalPrecio || 0;
    var total_pc = props.total_pc || 0;
    var fecha_i = props.fecha_i;
    var fecha_f = props.fecha_f;
    var totalPeso = props.totalPeso || 0;
    var joyeria = props.joyeria;
    var telas = props.telas;
    var total_precio = props.total_precio || 0;
    var movimiento = props.movimiento;

    function getTipoMovimientoTexto(tipo_ajuste) {
        if (tipo_ajuste === "Conteo") return "Conteo de productos";
        return "Inventario real de productos";
    }

    // Separar productos contados y no contados
    var productosContados = [];
    var productosNoContados = [];

    for (var i = 0; i < data.length; i++) {
        if (data[i].fue_contado) {
            productosContados.push(data[i]);
        } else {
            productosNoContados.push(data[i]);
        }
    }

    return (
        <div className="table-responsive p-3">
            <div className="card shadow-sm mb-4">
                <div className="card-header bg-primary text-white">
                    <h5 className="card-title mb-0">Detalle del Inventario</h5>
                </div>

                <div className="card-body">
                    {!hideCabecera && movimiento && (
                        <div className="mb-3 p-3" style={{ backgroundColor: "#f1f3f5", borderRadius: "5px" }}>
                            <p className="mb-1">
                                <strong>Tipo:</strong> {getTipoMovimientoTexto(movimiento.tipo_ajuste)}
                            </p>
                            <p className="mb-1">
                                <strong>Usuario:</strong> {movimiento.usuario_display}
                            </p>
                        </div>
                    )}

                    {!hideCabecera && (
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <p className="mb-1">
                                    <strong>Fecha inicio:</strong> <RenderDateTime fecha={fecha_i} />
                                </p>
                                <p className="mb-1">
                                    <strong>Fecha Fin:</strong> <RenderDateTime fecha={fecha_f} />
                                </p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1">
                                    <strong>Total Diferencia Precio:</strong> <RenderMoneda monto={totalPrecio} />
                                </p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1">
                                    <strong>Total Diferencia:</strong> <RenderNumero monto={totalDiferencia} />
                                </p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1">
                                    <strong>Total Precio Compra:</strong> <RenderNumero monto={total_pc} />
                                </p>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-1">
                                    <strong>Total Precio Público:</strong> <RenderNumero monto={total_precio} />
                                </p>
                            </div>
                            {joyeria && (
                                <div className="col-md-6">
                                    <p className="mb-1">
                                        <strong>Total Peso:</strong> {totalPeso} grs.
                                    </p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Tabla productos contados */}
                    {productosContados.length > 0 && (
                        <div className="mb-4">
                            <h6>Productos Contados ({productosContados.length})</h6>
                            <table className="table table-bordered">
                                <thead className="table-info">
                                    <tr>
                                        <th>Artículo</th>
                                        <th>Código</th>
                                        {conf_tipo_negocio === "Joyeria" && <th>Kilataje</th>}
                                        {conf_tipo_negocio === "Joyeria" && <th>Peso</th>}
                                        <th>Cant. Antes</th>
                                        <th>Cant. Después</th>
                                        <th>Diferencia</th>
                                        <th>Exist. Sistema</th>
                                        <th>Exist. Real</th>
                                        <th>Precio Público</th>
                                        <th>P. compra</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productosContados.map(function(detalle, idx) {
                                        var fraccion = detalle.fraccion;
                                        var existencias_antes = detalle.existencia_sistema || 0;
                                        var existencias_despues = detalle.existencia_contada || 0;
                                        var precio = detalle.precio || 0;
                                        var costo_promedio = detalle.costo_promedio || 0;
                                        var producto = fraccion.producto || {};
                                        var diferencia = existencias_despues - existencias_antes;
                                        var codigo = "---";
                                        if (fraccion.codigos_barras && fraccion.codigos_barras.length > 0) {
                                            codigo = fraccion.codigos_barras[0].codigo;
                                        }

                                        return (
                                            <tr key={idx}>
                                                <td>{fraccion.nombre || "---"}</td>
                                                <td>{codigo}</td>
                                                {conf_tipo_negocio === "Joyeria" && <td>{producto.kilataje || "---"}</td>}
                                                {conf_tipo_negocio === "Joyeria" && <td>{producto.peso || "---"}</td>}
                                                <td>{conf_tipo_negocio === "Telas" ? formatFraction(existencias_antes) : <RenderNumero monto={existencias_antes} />}</td>
                                                <td>{conf_tipo_negocio === "Telas" ? formatFraction(existencias_despues) : <RenderNumero monto={existencias_despues} />}</td>
                                                <td>{conf_tipo_negocio === "Telas" ? formatDifference(diferencia) : <RenderNumero monto={diferencia} />}</td>
                                                <td>{conf_tipo_negocio === "Telas" ? formatFraction(existencias_antes) : <RenderNumero monto={existencias_antes} />}</td>
                                                <td>{conf_tipo_negocio === "Telas" ? formatFraction(existencias_despues) : <RenderNumero monto={existencias_despues} />}</td>
                                                <td><RenderMoneda monto={precio} /></td>
                                                <td><RenderMoneda monto={costo_promedio} /></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Tabla productos no contados */}
                    {productosNoContados.length > 0 && (
                        <div>
                            <h6>Productos No Contados ({productosNoContados.length})</h6>
                            <table className="table table-bordered">
                                <thead className="table-warning">
                                    <tr>
                                        <th>Artículo</th>
                                        <th>Código</th>
                                        {conf_tipo_negocio === "Joyeria" && <th>Kilataje</th>}
                                        {conf_tipo_negocio === "Joyeria" && <th>Peso</th>}
                                        <th>Exist. Sistema</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productosNoContados.map(function(detalle, idx) {
                                        var fraccion = detalle.fraccion;
                                        var existencias_sistema = detalle.existencia_sistema || 0;
                                        var producto = fraccion.producto || {};
                                        var codigo = "---";
                                        if (fraccion.codigos_barras && fraccion.codigos_barras.length > 0) {
                                            codigo = fraccion.codigos_barras[0].codigo;
                                        }

                                        return (
                                            <tr key={idx}>
                                                <td>{fraccion.nombre || "---"}</td>
                                                <td>{codigo}</td>
                                                {conf_tipo_negocio === "Joyeria" && <td>{producto.kilataje || "---"}</td>}
                                                {conf_tipo_negocio === "Joyeria" && <td>{producto.peso || "---"}</td>}
                                                <td>{conf_tipo_negocio === "Telas" ? formatFraction(existencias_sistema) : <RenderNumero monto={existencias_sistema} />}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HistorialPDF;
